// recon-other-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'rco.age.d0to30': '0–30 días',
  'rco.age.d31to60': '31–60 días',
  'rco.age.d61to90': '61–90 días',
  'rco.age.over90': 'Más de 90 días',
  'rco.age.noDate': 'Sin fecha',
  'rco.noText': 'Sin texto',
  'rco.type.liability': 'Pasivo',
  'rco.type.asset': 'Activo',
  'rco.check.specVsLedger': 'Partidas especificadas frente al libro mayor',
  'rco.check.notFullySpecified': 'El saldo no está especificado por completo',
  'rco.check.sumsToLedger': 'Suma lo mismo que el libro mayor',
  'rco.check.older90': 'Partidas de más de 90 días',
  'rco.check.noCounterparty': 'Partidas sin contraparte identificada',
  'rco.check.unusualSign': 'Partidas con signo inusual',
  'rco.check.noMovement': 'Partidas sin movimiento en el periodo',
  'rco.check.manualAtPeriodEnd': 'Asientos manuales al cierre del periodo',
  'rco.check.roundAmounts': 'Importes redondos',
});
